import axios from "axios";

export interface INewUserAdmin {
  data?: {
    message?: string;
    userId?: string;
  };

  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  role?: string;
  _id?: string;
}

const BASE_URL = `${process.env.REACT_APP_API_URL}/admin`;

export const setNewUser = async (
  request: INewUserAdmin
): Promise<INewUserAdmin> =>
  axios.post(`${BASE_URL}/create-user`, request, {
    withCredentials: true,
  });

export const getAdminUsers = async () => {
  return axios.get(`${BASE_URL}/get-users`, {
    withCredentials: true,
  });
};

export const getErrorLogs = async () => {
  return axios.get(`${BASE_URL}/error-logs`, {
    withCredentials: true,
  });
};

export const updateAdminUser = async (
  userId: string,
  updateRequest: INewUserAdmin
): Promise<any> =>
  axios.put(`${BASE_URL}/update-user/${userId}`, updateRequest, {
    withCredentials: true,
  });

export const deleteAdminUser = async (userId: string): Promise<any> => {
  return axios.delete(`${BASE_URL}/delete-user/${userId}`, {
    withCredentials: true,
  });
};

export const backupData = async (password: string): Promise<any> => {
  return axios.post(
    `${BASE_URL}/saveBackupDatabase`,
    { password },
    {
      withCredentials: true,
    }
  );
};

export const getBackupStatus = async (): Promise<any> => {
  return axios.get(`${BASE_URL}/backups/status`, {
    withCredentials: true,
  });
};

export const downloadLatestBackup = async (password: string): Promise<any> => {
  return axios.post(
    `${BASE_URL}/backups/latest/download`,
    { password },
    {
      withCredentials: true,
    }
  );
};

export const lastUpdateBackup = async (): Promise<any> => {
  return axios.get(`${BASE_URL}/lists-backups`, {
    withCredentials: true,
  });
};
